<!-- =========================================================================================
  File Name: PackageList.vue
  Description: Packaage List page
========================================================================================== -->
<template>
  <div id="page-user-list">
    <vs-alert v-if="!hasNewCredentials" color="danger" title="Atenção - Mudança no SIGEP (Web Master)" active="true" class="mb-5">
      <span>Os Correios estão mudando o <code>SIGEP (Web Master)</code>. Para continuar a usar os serviços dos Correios, cadastre-se no <a href="https://meucorreios.correios.com.br/app/index.php" target="_blank" >Meu Correios</a> e preencha os dados na aba de <a href="/credentials/sigep">credenciais</a> na seção de <code>Novas Credenciais dos Correios</code>.</span>
      <br/>
      <span>Caso as novas credenciais dos correios não sejam preenchidas e validadas, as etiquetas não serão emitidas!</span>
    </vs-alert>
    <p class="mb-5">
      Nessa tela você poderá ver todos os pedidos sincronizados da sua loja. Para atualizar os mais recentes clique em <code>Ações</code> / <code>Sincronizar Pedidos</code> e aguarde.
    </p>
    <vs-alert active="true" class="mb-5">
      <span></span>
      <span>Para poder gerar uma PLP, a coluna <code>ok?</code> precisa estar <code>ROXA</code>. Caso não esteja, entre na ordem e faça as devidas alterações.</span>
    </vs-alert>
    <p class="mb-5">
      Por fim, basta <code>selecionar os pedidos</code> que já possuem etiquetas geradas e clicar em <code>Ações</code> / <code>Fechar PLP</code>. Depois basta seguir as instruções.
    </p>
    <p class="mb-10">
      Qualquer dúvida entre em contato conosco via e-mail para <code>support@gadolapps.com</code>
    </p>
    <!-- <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
        <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Role</label>
                <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Status</label>
                <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Verified</label>
                <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Department</label>
                <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
            </div>
        </div>
    </vx-card> -->
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ packagesData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : packagesData.length }} de {{ packagesData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">Ações</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="submitSelectedPackages">
              <span class="flex items-center">
                <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Atualizar etiqueta(s)</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="syncPackages">
              <span class="flex items-center">
                <feather-icon icon="RotateCwIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Forçar Sincronização dos últimos 25 Pedidos</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="packagesData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true" :floatingFilter="false" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :enableRtl="$vs.rtl" :localeText="localeText">
      </ag-grid-vue>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import modulePackageManagement from '@/store/package-management/modulePackageManagement.js'

// Cell Renderer
import CellRendererDate from "./cell-renderer/CellRendererDate.vue"
import CellRendererDestination from "./cell-renderer/CellRendererDestination.vue"
import CellRendererPayment from "./cell-renderer/CellRendererPayment.vue"
import CellRendererFulfillment from "./cell-renderer/CellRendererFulfillment.vue"
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import CellRendererLinkPLP from "./cell-renderer/CellRendererLinkPLP.vue"
import CellRendererLinkLabel from "./cell-renderer/CellRendererLinkLabel.vue"
import CellRendererCarrierKind from "./cell-renderer/CellRendererCarrierKind.vue"
import CellRendererCarrier from "./cell-renderer/CellRendererCarrier.vue"

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererDate,
    CellRendererDestination,
    CellRendererPayment,
    CellRendererFulfillment,
    CellRendererActions,
    CellRendererLinkPLP,
    CellRendererLinkLabel,
    CellRendererCarrierKind,
    CellRendererCarrier,
  },
  data() {
    return {

      // Filter Options
      roleFilter: {
        label: 'All',
        value: 'all'
      },
      roleOptions: [{
          label: 'All',
          value: 'all'
        },
        {
          label: 'Admin',
          value: 'admin'
        },
        {
          label: 'User',
          value: 'user'
        },
        {
          label: 'Staff',
          value: 'staff'
        },
      ],

      statusFilter: {
        label: 'All',
        value: 'all'
      },
      statusOptions: [{
          label: 'All',
          value: 'all'
        },
        {
          label: 'Active',
          value: 'active'
        },
        {
          label: 'Deactivated',
          value: 'deactivated'
        },
        {
          label: 'Blocked',
          value: 'blocked'
        },
      ],

      isVerifiedFilter: {
        label: 'All',
        value: 'all'
      },
      isVerifiedOptions: [{
          label: 'All',
          value: 'all'
        },
        {
          label: 'Yes',
          value: 'yes'
        },
        {
          label: 'No',
          value: 'no'
        },
      ],

      departmentFilter: {
        label: 'All',
        value: 'all'
      },
      departmentOptions: [{
          label: 'All',
          value: 'all'
        },
        {
          label: 'Sales',
          value: 'sales'
        },
        {
          label: 'Development',
          value: 'development'
        },
        {
          label: 'Management',
          value: 'management'
        },
      ],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      localeText: {
        page: 'daPage',
        more: 'daMore',
        to: 'daTo',
        of: 'daOf',
        next: 'daNexten',
        last: 'daLasten',
        first: 'daFirsten',
        previous: 'daPreviousen',
        loadingOoo: 'daLoading...',
        selectAll: 'daSelect Allen',
        searchOoo: 'daSearch...',
        blanks: 'daBlanc',
        filterOoo: 'daFilter...',
        equals: 'daEquals',
        notEqual: 'daNotEqual',
        dateFormatOoo: 'daYyyy-mm-dd',
        lessThan: 'daLessThan',
        greaterThan: 'daGreaterThan',
        lessThanOrEqual: 'daLessThanOrEqual',
        greaterThanOrEqual: 'daGreaterThanOrEqual',
        inRange: 'daInRange',
        inRangeStart: 'daRangeStart',
        inRangeEnd: 'daRangeEnd',
        contains: 'daContains',
        notContains: 'daNotContains',
        startsWith: 'daStarts dawith',
        endsWith: 'daEnds dawith',
        andCondition: 'daAND',
        orCondition: 'daOR',
        applyFilter: 'daApply',
        resetFilter: 'daReset',
        clearFilter: 'daClear',
        group: 'laGroup',
        columns: 'laColumns',
        filters: 'laFilters',
        rowGroupColumns: 'laPivot Cols',
        rowGroupColumnsEmptyMessage: 'la drag cols to group',
        valueColumns: 'laValue Cols',
        pivotMode: 'laPivot-Mode',
        groups: 'laGroups',
        values: 'laValues',
        pivots: 'laPivots',
        valueColumnsEmptyMessage: 'la drag cols to aggregate',
        pivotColumnsEmptyMessage: 'la drag here to pivot',
        toolPanelButton: 'la tool panel',
        noRowsToShow: 'Nenhuma ordem sincronizada ainda',
        enabled: 'laEnabled',
        pinColumn: 'laPin Column',
        valueAggregation: 'laValue Agg',
        autosizeThiscolumn: 'laAutosize Diz',
        autosizeAllColumns: 'laAutsoie em All',
        groupBy: 'laGroup by',
        ungroupBy: 'laUnGroup by',
        resetColumns: 'laReset Those Cols',
        expandAll: 'laOpen-em-up',
        collapseAll: 'laClose-em-up',
        toolPanel: 'laTool Panelo',
        export: 'laExporto',
        csvExport: 'laCSV Exportp',
        excelExport: 'laExcel Exporto (.xlsx)',
        excelXmlExport: 'laExcel Exporto (.xml)',
        pivotChartAndPivotMode: 'laPivot Chart & Pivot Mode',
        pivotChart: 'laPivot Chart',
        chartRange: 'laChart Range',
        columnChart: 'laColumn',
        groupedColumn: 'laGrouped',
        stackedColumn: 'laStacked',
        normalizedColumn: 'la100% Stacked',
        barChart: 'laBar',
        groupedBar: 'laGrouped',
        stackedBar: 'laStacked',
        normalizedBar: 'la100% Stacked',
        pieChart: 'laPie',
        pie: 'laPie',
        doughnut: 'laDoughnut',
        line: 'laLine',
        xyChart: 'laX Y (Scatter)',
        scatter: 'laScatter',
        bubble: 'laBubble',
        areaChart: 'laArea',
        area: 'laArea',
        stackedArea: 'laStacked',
        normalizedArea: 'la100% Stacked',
        pinLeft: 'laPin &lt;&lt;',
        pinRight: 'laPin &gt;&gt;',
        noPin: 'laDontPin &lt;&gt;',
        sum: 'laSum',
        min: 'laMin',
        max: 'laMax',
        none: 'laNone',
        count: 'laCount',
        average: 'laAverage',
        filteredRows: 'laFiltered',
        selectedRows: 'laSelected',
        totalRows: 'laTotal Rows',
        totalAndFilteredRows: 'laRows',
        copy: 'laCopy',
        copyWithHeaders: 'laCopy With Headers',
        ctrlC: 'laCtrl n C',
        paste: 'laPaste',
        ctrlV: 'laCtrl n V',
        pivotChartTitle: 'laPivot Chart',
        rangeChartTitle: 'laRange Chart',
        settings: 'laSettings',
        data: 'laData',
        format: 'laFormat',
        categories: 'laCategories',
        defaultCategory: '(laNone)',
        series: 'laSeries',
        xyValues: 'laX Y Values',
        paired: 'laPaired Mode',
        axis: 'laAxis',
        color: 'laColor',
        thickness: 'laThickness',
        xType: 'laX Type',
        automatic: 'laAutomatic',
        category: 'laCategory',
        number: 'laNumber',
        time: 'laTime',
        xRotation: 'laX Rotation',
        yRotation: 'laY Rotation',
        ticks: 'laTicks',
        width: 'laWidth',
        length: 'laLength',
        padding: 'laPadding',
        chart: 'laChart',
        title: 'laTitle',
        background: 'laBackground',
        font: 'laFont',
        top: 'laTop',
        right: 'laRight',
        bottom: 'laBottom',
        left: 'laLeft',
        labels: 'laLabels',
        size: 'laSize',
        minSize: 'laMinimum Size',
        maxSize: 'laMaximum Size',
        legend: 'laLegend',
        position: 'laPosition',
        markerSize: 'laMarker Size',
        markerStroke: 'laMarker Stroke',
        markerPadding: 'laMarker Padding',
        itemPaddingX: 'laItem Padding X',
        itemPaddingY: 'laItem Padding Y',
        strokeWidth: 'laStroke Width',
        offset: 'laOffset',
        offsets: 'laOffsets',
        tooltips: 'laTooltips',
        callout: 'laCallout',
        markers: 'laMarkers',
        shadow: 'laShadow',
        blur: 'laBlur',
        xOffset: 'laX Offset',
        yOffset: 'laY Offset',
        lineWidth: 'laLine Width',
        normal: 'laNormal',
        bold: 'laBold',
        italic: 'laItalic',
        boldItalic: 'laBold Italic',
        predefined: 'laPredefined',
        fillOpacity: 'laFill Opacity',
        strokeOpacity: 'laLine Opacity',
        columnGroup: 'laColumn',
        barGroup: 'laBar',
        pieGroup: 'laPie',
        lineGroup: 'laLine',
        scatterGroup: 'laScatter',
        areaGroup: 'laArea',
        groupedColumnTooltip: 'laGrouped',
        stackedColumnTooltip: 'laStacked',
        normalizedColumnTooltip: 'la100% Stacked',
        groupedBarTooltip: 'laGrouped',
        stackedBarTooltip: 'laStacked',
        normalizedBarTooltip: 'la100% Stacked',
        pieTooltip: 'laPie',
        doughnutTooltip: 'laDoughnut',
        lineTooltip: 'laLine',
        groupedAreaTooltip: 'laGrouped',
        stackedAreaTooltip: 'laStacked',
        normalizedAreaTooltip: 'la100% Stacked',
        scatterTooltip: 'laScatter',
        bubbleTooltip: 'laBubble',
        noDataToChart: 'laNo data available to be charted.',
        pivotChartRequiresPivotMode: 'laPivot Chart requires Pivot Mode enabled.',
      },
      columnDefs: [{
          headerName: '#',
          field: 'optional.number',
          width: 150,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          sort: 'desc'
        },
        {
          headerName: 'Data',
          field: 'optional.date',
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererDate'
        },
        {
          headerName: 'ok?',
          field: 'destination.valid',
          filter: true,
          width: 75,
          cellRendererFramework: 'CellRendererDestination'
        },
        {
          headerName: 'Modo',
          field: 'transportadora',
          filter: true,
          width: 125,
          cellRendererFramework: 'CellRendererCarrier'
        },
        {
          headerName: 'Tipo',
          field: 'tipo',
          filter: true,
          width: 300,
          cellRendererFramework: 'CellRendererCarrierKind'
        },
        {
          headerName: 'Pagamento',
          field: 'optional.payment',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererPayment'
        },
        {
          headerName: 'Envio',
          field: 'optional.fulfillment',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererFulfillment'
        },
        {
          headerName: 'Etiqueta',
          field: 'tracking',
          filter: true,
          width: 175,
          cellRendererFramework: 'CellRendererLinkLabel',
          tooltipField: 'tracking.label_error'
        },
        {
          headerName: 'Prépostagem',
          field: 'id',
          filter: true,
          width: 250,
          cellRendererFramework: 'CellRendererLinkPLP',
          tooltipField: 'tracking.id_error',
        },
        {
          headerName: 'Ações',
          field: 'transactions',
          width: 150,
          cellRendererFramework: 'CellRendererActions',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererDate,
        CellRendererDestination,
        CellRendererPayment,
        CellRendererFulfillment,
        CellRendererActions,
        CellRendererLinkPLP,
        CellRendererLinkLabel,
        CellRendererCarrierKind,
        CellRendererCarrier,
      }
    }
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value)
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value)
    },
    isVerifiedFilter(obj) {
      let val = obj.value === "all" ? "all" : obj.value == "yes" ? "true" : "false"
      this.setColumnFilter("is_verified", val)
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value)
    },
  },
  computed: {
    hasNewCredentials() {
      let newCredentials = this.$store.state.sigep.info.cartao_postagem_api != undefined
         &&  this.$store.state.sigep.info.senha_api != undefined
         &&  this.$store.state.sigep.info.usuario_api != undefined
         &&  this.$store.state.sigep.info.valid;

      console.log(newCredentials);
      return newCredentials;
    },
    packagesData() {
      return this.$store.state.packageManagement.packages
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 100
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== "all") {
        modelObj = {
          type: "equals",
          filter: val
        }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: 'All',
        value: 'all'
      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    submitSelectedPackages() {

      this.$vs.loading();

      const selectedRows = this.gridApi.getSelectedRows();
      let selectedIDs = selectedRows.map(item => item.id)

      if (selectedIDs.length === 0) {
        this.$vs.dialog({
          color: 'warning',
          title: 'Nenhum pedido selecionado',
          text: 'Selecione ao menos 1 pedido e tente novamente',
          acceptText: 'OK',
          buttonCancel: false
        })
        return
      }

      this.$store.dispatch("packageManagement/updatePackage", selectedIDs)
        .then(res => {
          console.log(res)
          this.$vs.loading.close();
        })
        .catch(err => {
          console.error({ err: err.response })
          this.$vs.notify({
            time: 20000,
            title: 'Atenção',
            text: `${err.response.data.message}`,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.$vs.loading.close();
        })
    },
    syncPackages() {

      this.$vs.loading();

      this.$store.dispatch("packageManagement/syncPackages")

        .then(() => {

          this.$vs.notify({
            time: 20000,
            title: 'Tudo certo!',
            text: 'Pedido de sincronização realizado com sucesso. Por favor, aguarde alguns minutos e atualize a página para ver os resultados',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          this.$vs.loading.close();

        })
        .catch(() => {
          this.$vs.notify({
            time: 20000,
            title: 'Erro!',
            text: 'Ocorreu um erro, por favor, tente novamente',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
          this.$vs.loading.close();

        })
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px"
    }
  },
  created() {
    if (!modulePackageManagement.isRegistered) {
      this.$store.registerModule('packageManagement', modulePackageManagement)
      modulePackageManagement.isRegistered = true
    }
    this.$store.dispatch("packageManagement/fetchPackages").catch(() => {
      // console.error(err)
    })
  }
}

</script>
<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

</style>
